<div class="container-fluid stdTheme " *ngIf="okToDisplay" style="height: 700px!important; overflow-y: hidden;">
    <ng-container *ngTemplateOutlet="tasksListTemplate"></ng-container>
</div>
<ng-template #tasksListTemplate >
    <div class="flex-row row stdTheme" style="margin: 0px;margin-top: 20px">
        <div class="actionsReferenced stdTheme col-3" style="padding: 0px" >
            <div class="flex-row row rowEquipment d-flex justify-content-center" style="margin: 0px; padding: 0px"  >
                <div class="col-5 d-flex justify-content-start" style="padding-left: 0px;padding-right: 0px;">
                    {{ 'CreateTask' | translate }}
                </div>
                <div class="col-1 d-flex justify-content-start" style="padding-left: 0px;padding-right: 0px;">
                   
                </div>
                <div class="col-1 d-flex justify-content-start" style="padding-left: 0px;padding-right: 0px;">
                    <button mat-icon-button class="buttonTheme"  [disabled]="isReadOnly" style="padding-right: 10px;" (click)="addTask();">
                        <mat-icon class="reorder" >add</mat-icon>
                    </button>
                </div>
            </div>
            <div class="lineWks" style="margin-top: 5px;"></div>
            <div *ngIf="rowJobsTask !== undefined && rowJobsTask.length > 0">  
              
                <div class="flex-row row rowTask "  style="margin: 0px; padding: 0px">
                    <div class="stdTheme w-100" *ngFor="let taskRow of rowJobsTask; let idxTask = index"  >
                        <fieldset class="rowTask-border" style="margin-bottom: 10px"
                                [ngClass]="{'greenBorder':!waitPricing[idxTask],'redBorder':waitPricing[idxTask]}">   
                            <div class="flex-row row rowEquipment " [ngClass]="{'taskrubrics': !taskRow.selected,'taskrubricsSelected': taskRow.selected}">
                                <div class="col-1 d-flex justify-content-start divTask" style="padding-left: 0px;padding-right: 0px;">
                                    <button mat-icon-button matSuffix [disabled]="isReadOnly" (click)="taskSelectRemoveOK(idxTask);">
                                        <mat-icon class="reorder" >delete_sweep</mat-icon>
                                    </button>
                                </div>
                                <div class="col-9 d-flex justify-content-start divTask" style="padding-left: 0px;padding-right: 0px;"
                                    [ngClass]="{'taskSelected':taskRow.selected,'rowTask':!taskRow.selected }">
                                    <input id="taskrefLabel" #taskrefLabel class="inputTheme" style="margin-top: 5px;text-align: start;"
                                            type="text" value="{{taskRow.workTask.taskrefLabel}}"
                                            title="{{taskRow.workTask.id}}"
                                            [ngClass]="{'taskrubrics': !taskRow.selected,'taskrubricsSelected': taskRow.selected}"
                                            (change)="setTaskLabelValue(taskrefLabel.value,  idxTask)"
                                            [readonly]="isReadOnly"
                                            matInput placeholder="{{ 'taskrefLabel' | translate }}">
                                </div>
                                <div class="col-1 d-flex justify-content-start" style="padding-left: 0px;padding-right: 0px;">
                                    <button mat-icon-button (click)="toggleRowTask(idxTask, rowJobsTask[idxTask].detailCollapse)" 
                                        title="{{'detail row' | translate }}">
                                       <span *ngIf="rowJobsTask[idxTask].detailCollapse"  >
                                            <i class="fa fa-chevron-down" style="font-size: 15px"></i>
                                        </span>
                                        <span *ngIf="!rowJobsTask[idxTask].detailCollapse" >
                                            <i class="fa fa-chevron-up" style="font-size: 15px"></i>
                                        </span>
                                    </button> 
                                </div>
                                <!--[ngClass]="{'greenBorder':!waitPricing[idxTask],'redBorder':waitPricing[idxTask]}" -->
                                <div class="col-1 d-flex justify-content-start divTask " style="padding-left: 0px;padding-right: 0px;">
                                    <button mat-icon-button [disabled]="!taskRow.selectedEquipments" matSuffix  (click)="displaySelectedTask(idxTask);" >
                                        <mat-icon  class="reorder">details</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <div *ngIf="!taskRow.detailCollapse" class="stdTheme" style="margin-top: 10px; margin-bottom: 10px">
                                <div class="lineWks" style="margin-top: 5px;"></div>
                                <div *ngFor="let equipmentCur of taskRow.equipments; let idxEquip = index"  >
                                    <div  class="flex-row row rowEquipment" 
                                            [ngClass]="{
                                                'rowEquipmentOdd': (equipmentCur.isOdd),
                                                'rowEquipmentEven': (equipmentCur.isEven)
                                            }"
                                        (click)="selectedEquipement(idxTask, idxEquip, equipmentCur)">
                                        <div class="col-9 d-flex justify-content-start" style="padding-left: 0px;padding-right: 0px;" >
                                            <span *ngIf="equipmentCur.jsonData === undefined || equipmentCur.jsonData === null " style="margin-left: 0px">
                                                {{equipmentCur.label }}
                                            </span>
                                            <div *ngIf="equipmentCur.jsonData !== undefined && equipmentCur.jsonData !== null ">
                                                <span *ngIf="equipmentCur.jsonData?.SN !== '' && equipmentCur.jsonData?.model !== ''" style="margin-left: 0px; font-size: 14px">
                                                    {{equipmentCur.label}} (SN : {{equipmentCur.jsonData.SN}}) {{equipmentCur.jsonData.model}}
                                                </span>
                                                <span *ngIf="equipmentCur.jsonData?.SN !== '' && equipmentCur.jsonData?.model === ''" style="margin-left: 0px; font-size: 14px">
                                                    {{equipmentCur.label}} (SN : {{equipmentCur.jsonData.SN}}) 
                                                </span>
                                                <span *ngIf="equipmentCur.jsonData?.SN === '' && equipmentCur.jsonData?.model !== ''" style="margin-left: 0px; font-size: 14px">
                                                    {{equipmentCur.label}} {{equipmentCur.jsonData.model}}
                                                </span>
                                            </div>
                                            
                                        </div>
                                        <div class="col-3 " style="padding-left: 0px;padding-right: 0px;">
                                            <mat-checkbox  id="checkEquipment"  #checkEquipment  
                                                        class="stdTheme mdiinput"  
                                                        [(ngModel)]="equipmentCur.selected"
                                                        [disabled]="true">
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-9" *ngIf="openedAccordion && parentTask.statutCall !== 'accordion'" >
            <div class="flex-row row stdTheme" style="margin: 0px; overflow-x: hidden; overflow-y: hidden;">
                <div class="col-1">
                    <button [disabled]="!okToDuplicate" mat-button title="{{'duplicate label' | translate }}" (click)="duplicateTask()">
                        <i class="fa fa-clone" ></i>
                    </button>
                </div>
                <div class="col-9 d-flex justify-content-center divTask" style="padding-left: 0px;padding-right: 0px;">
                    <h5 class="titleTheme" style="padding-top: 10px;">{{titleTask}} - {{ 'check list' | translate }}</h5>
                </div>
                <div class="col-2 d-flex justify-content-center divTask" style="padding-left: 0px;padding-right: 0px;">
                    <button *ngIf="!isReadOnly" mat-button (click)="toggleSidenavRight('')">

                        <span *ngIf="!sidenavRight.opened"  >
                            <i class="fa fa-angle-right fa-2x"  style="margin-right: 10px;"></i>
                        </span>
                        <span  >
                            {{ 'tasksReferenced' | translate }}
                        </span>
                        <span *ngIf="sidenavRight.opened" >
                            <i class="fa fa-angle-left fa-2x" style="margin-left: 10px;"></i>
                        </span>
                    </button>
                </div>
            </div>
            <div class="flex-row row rowEquipment" style="margin: 0px; padding: 0px"  >
                <mat-sidenav-container class="stdTheme w-100 mat-elevation-z12" style="margin-right: 10px; margin-left: 10px; height: 600px!important">
                    <mat-sidenav  #sidenavRight mode="side" [(opened)]="openedRight" position="end" 
                                    (opened)="onChangeActionSidenav('openedRight open!')"
                                    (closed)="onChangeActionSidenav('openedRight close!')">
                        <div class="container-fluid stdTheme right-sidenav" style="height: 100%;">
                            <div class="flex-row row stdTheme mat-elevation-z20" style="margin: 0px;">
                                <div class="actionsReferenced stdTheme col-12"  style="padding: 0px" >
                                    <mat-select id="workCode" placeholder="{{ 'workCode' | translate }}" #workCode
                                            panelClass="mdiselectcontent"   ngDefaultControl 
                                            (selectionChange)="onChangeWorkTask(workCode.value)" >
                                        <mat-option class="selectOptionsTheme" *ngFor="let workCodeCur of workCodeList"  
                                            [value]="workCodeCur.value"  >{{workCodeCur.label}}
                                        </mat-option>
                                    </mat-select>
                                    <button mat-icon-button matPrefix aria-label="search" >
                                        <mat-icon>search</mat-icon>
                                    </button>
                                    <input class="searchTheme" #filterTasks placeholder="{{ 'filterInput' | translate }}" 
                                            (keyup)="onKeyFilterTasks($event)" >
                                    <button mat-icon-button matSuffix aria-label="clear" 
                                            *ngIf="filterTasks.value" (click)="filterTasks.value=''; onKeyFilterTasks('');">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <div >
                                        <table class="table listAction stdTheme" id="tasksReferenced"  >
                                            <thead *ngIf="!isReadOnly" >
                                                <th colspan="3" >
                                                    <button mat-button class="buttonTheme" 
                                                        style="margin-left: 10px;margin-right: 10px;" (click)="addTaskReferenced()">
                                                            {{ 'CreateReferencedTask' | translate }}
                                                        <i class="fa fa-plus-square" style="margin-left: 10px; font-size: 20px" ></i>
                                                    </button>
                                                    <button mat-button class="buttonTheme" 
                                                        style="margin-left: 10px;margin-right: 10px;" (click)="refreshTaskReferenced()">
                                                        {{ 'Refresh' | translate }}
                                                    <i class="fas fa-redo" style="margin-left: 10px; font-size: 20px" ></i>
                                                </button>
                                                </th>
                                                    <th style="width: 5%"></th>
                                            </thead>
                                            <tbody >
                                                <div *ngFor="let referencedTaskCur of tasksReferenced; let i = index" >
                                                    <tr class="curAction curActionReferenced" *ngIf="referencedTaskCur.selectedTask === false" >
                                                        <td style="width: 100%; text-align: left;">
                                                            <button mat-button 
                                                            matTooltip={{referencedTaskCur.snTooltip}} 
                                                            matTooltipClass="custom-tooltip multiline-tooltip"
                                                            matTooltipPosition="above"
                                                            (click)="referencedToSelectedTask(i);">
                                                                {{referencedTaskCur.taskrefLabel}}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </div>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>  
                        </div>
                    </mat-sidenav>
            
                    <mat-sidenav-content  class="stdTheme" (click)="toggleSidenavRight('close')">
                        <div class="container-fluid stdTheme " style="overflow-x: hidden; overflow-y: hidden;">
                            <div class="flex-row row " style="margin: 0px;" style="overflow-x: hidden; overflow-y: hidden;">
                                
                                <div class="col-12 actionsReferenced stdTheme contentTasks" style="padding: 0px;overflow-x: hidden; overflow-y: hidden;">                                    
                                    <div *ngIf="openedAccordion && parentTask.statutCall !==  'accordion'" >
                                        <div class="flex-row row stdTheme" style="margin: 0px; overflow-x: hidden; overflow-y: hidden;">
                                            <mdi-taskref-rubrics style="width: 100%;" 
                                                [parentTask] = "parentTask"
                                                [ihmOptions]="ihmOptions"
                                                [tasksActionsContent]="tasksActionsContent"
                                                [tasksActionsParentContent]="tasksActionsParentContent"
                                                [actionType]="priceOption"
                                                [wksEntity]="wksEntity"
                                                [orig]="'workCard'"
                                                [rowTask]="rowTask"
                                                [isAlreadyOpen]="isAlreadyOpen"
                                                (dataOut)="statutCur($event)">
                                            </mdi-taskref-rubrics>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-sidenav-content>
                </mat-sidenav-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #taskReferencedModal >
    <!--
    <div class="modal-header">
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    -->
    <div class="modal-content" style="height: 750px!important; overflow-y: hidden!important;">
        <div class="modal-body modal-works-tasks-body" >
            <mdi-tasksref-card style="width: 100%;"
                [tasksrefList]="undefined"
                [optionItem]="'works'" 
                [actionType]="'add'" 
                [parentTask]="parentTaskRef"
                [ihmOptions]="ihmOptions">
        </mdi-tasksref-card>
        </div>
    </div>
     
  </ng-template>